import {
    css, Theme,
} from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        container: css`
            ${custom.boxShadowRadius};
            ${custom.border};
            overflow: hidden;
            cursor: pointer;
            padding: 10px 8px 4px 12px;
            min-width: 320px;
        `,
        numberLine: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 10px;
        `,
        active: css`
            color: ${theme.palette.primary.main};
            height: ${theme.typography.h3.lineHeight};
        `,
        tempContainer: css`
            display: inline-flex;
        `,
        numberLineLetters: css`
            line-height: ${theme.typography.h2.lineHeight};
        `,
        tempImg: css`
            width: 20px;
            height: 36px;
        `,
        numberTypeContainer: css`
            display: inline-flex;
        `,
        bottomWrapper: css`
            box-sizing: border-box;
            min-height: 72px;
        `,
        bottomText: css`
            min-height: ${theme.typography.h3.lineHeight};
        `,
    }
}

export default styles
